import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from "react";

type FeatureProviderProps = {
  children: ReactNode;
};

type FeatureContextData = {
  featureToggle: boolean;
  productsToggle: boolean;
  paymentMethodsToggle: boolean;
  pricesToggle: boolean;
};

export const FeatureContext = createContext({} as FeatureContextData);

export function FeatureProvider({ children }: FeatureProviderProps) {
  const [featureToggle, setFeatureToggle] = useState(false);
  const [productsToggle, setProductsToggle] = useState(false);
  const [paymentMethodsToggle, setPaymentMethodsToggle] = useState(false);
  const [pricesToggle, setPricesToggle] = useState(false);

  useEffect(() => {
    setFeatureToggle(false);
    setProductsToggle(true);
    setPaymentMethodsToggle(false);
    setPricesToggle(false);
  }, []);

  return (
    <FeatureContext.Provider
      value={{
        featureToggle,
        productsToggle,
        paymentMethodsToggle,
        pricesToggle
      }}
    >
      {children}
    </FeatureContext.Provider>
  );
}

export function useFeatureToggle(): FeatureContextData {
  const context = useContext(FeatureContext);

  return context;
}
